import { render, staticRenderFns } from "./Y01P.vue?vue&type=template&id=2412923a&scoped=true"
import script from "./Y01P.vue?vue&type=script&lang=js"
export * from "./Y01P.vue?vue&type=script&lang=js"
import style0 from "./Y01P.vue?vue&type=style&index=0&id=2412923a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2412923a",
  null
  
)

export default component.exports